import { useState } from "react";
import { 
  FiX, 
  FiAlertCircle, 
  FiShield,
  FiMail
} from "react-icons/fi";
import { useAuth } from "../contexts/AuthContext";

const ModalAuth = ({ closeModal, onAuthSuccess }) => {
  const { loginWithGoogle } = useAuth();
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      closeModal();
      setClosing(false);
    }, 250);
  };

  const handleGoogleLogin = async () => {
    setErrorMessage("");
    setLoadingGoogle(true);
    try {
      await loginWithGoogle();
      handleClose();
      onAuthSuccess && onAuthSuccess();
    } catch (err) {
      setErrorMessage("Échec de la connexion avec Google. Veuillez réessayer.");
    }
    setLoadingGoogle(false);
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50 p-4">
      <div
        className={`
          relative bg-gradient-to-br from-white to-gray-50 rounded-3xl p-8 max-w-lg w-full
          transform transition-all duration-300 shadow-2xl
          ${closing ? "animate-modalOut" : "animate-modalIn"}
        `}
      >
        {/* Bouton fermer */}
        <button
          onClick={handleClose}
          className="absolute top-5 right-5 p-2 rounded-full hover:bg-gray-100 transition-colors group"
        >
          <FiX size={22} className="text-gray-500 group-hover:text-gray-700" />
        </button>

        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-r from-blue-500 to-teal-500 rounded-2xl flex items-center justify-center shadow-lg">
            <FiMail className="text-white text-3xl" />
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mb-3">
           Connexion à votre espace
          </h2>

        </div>

        {/* Bouton Google */}
        <button
          onClick={handleGoogleLogin}
          disabled={loadingGoogle}
          className={`
            w-full py-4 px-6 bg-white border-2 border-gray-300 rounded-xl
            font-medium text-gray-800 hover:border-blue-400 hover:bg-blue-50
            transition-all duration-300 flex items-center justify-center gap-4
            ${loadingGoogle ? "animate-pulse" : "hover:shadow-lg hover:-translate-y-0.5"}
            disabled:opacity-70 disabled:cursor-not-allowed
          `}
        >
          {loadingGoogle ? (
            <>
              <div className="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
              <span>Connexion en cours...</span>
            </>
          ) : (
            <>
              <svg className="w-6 h-6" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              <span className="font-semibold">Continuer avec Google</span>
            </>
          )}
        </button>

        {/* Indicateur sécurité */}
        <div className="mt-4 flex items-center justify-center gap-2 text-sm text-gray-500">
          <FiShield className="text-green-500" />
          <span>Connexion 100% sécurisée par Google</span>
        </div>

        {/* Message d’erreur */}
        {errorMessage && (
          <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-xl animate-shake">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-red-100 rounded-full">
                <FiAlertCircle className="text-red-600" />
              </div>
              <div>
                <p className="font-medium text-red-800">Une erreur est survenue</p>
                <p className="text-sm text-red-600 mt-1">{errorMessage}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalAuth;
